import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=22d6ab12&scoped=true&"
import script from "./TableList.vue?vue&type=script&lang=js&"
export * from "./TableList.vue?vue&type=script&lang=js&"
import style0 from "./TableList.vue?vue&type=style&index=0&id=22d6ab12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6ab12",
  null
  
)

export default component.exports